'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var bookingType = exports.bookingType = ["Standard_Process", "Defer_to_Venue"];